(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach((form) => {
    const select = form.querySelector('[data-sort-select]');
    if (select) {
      select.addEventListener('change', () => form.submit());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
